// Mapa de tom -> indice usado pelo parametro "keyShape" do Cifra Club.
//
// Descoberto empiricamente (17/10/2026), confirmado pelo Drigo com 3 exemplos
// em duas musicas de tom nativo diferente:
//   "Digno E o Senhor" (nativa G): keyShape=0 -> A, keyShape=2 -> B
//   "Poderoso Deus" (nativa D): keyShape=6 -> Eb, keyShape=7 -> E
// Os 3 batem exatos com uma escala cromatica FIXA comecando em A (A=0),
// independente do tom original da musica -- ou seja, nao e um indice
// relativo ao tom nativo, e sim um indice absoluto:
//   A=0  A#/Bb=1  B=2  C=3  C#/Db=4  D=5  D#/Eb=6  E=7  F=8  F#/Gb=9  G=10  G#/Ab=11
//
// Nao confirmado ainda: como o Cifra Club trata tons menores (ex: "Em",
// "F#m"). Assumimos que o indice usa so a nota da fundamental, ignorando o
// sufixo "m" -- e a suposicao mais razoavel (a transposicao move a
// fundamental, a qualidade maior/menor fica nos proprios acordes da pagina),
// mas vale testar com uma musica menor se algum dia aparecer link errado.
const KEY_SHAPE_INDEX = {
  A: 0,
  "A#": 1,
  BB: 1, // Bb
  B: 2,
  C: 3,
  "C#": 4,
  DB: 4, // Db
  D: 5,
  "D#": 6,
  EB: 6, // Eb
  E: 7,
  F: 8,
  "F#": 9,
  GB: 9, // Gb
  G: 10,
  "G#": 11,
  AB: 11 // Ab
};

// Converte um tom cadastrado (ex: "G", "F#m", "Bb") no indice "keyShape" do
// Cifra Club. Retorna null se o tom estiver vazio ou nao reconhecido (nao
// quebra nada, so nao aplica a transposicao automatica).
export function keyShapeFor(tom) {
  if (!tom) return null;
  const cleaned = tom
    .trim()
    .replace(/m$/i, "")
    .trim()
    .toUpperCase();
  return Object.prototype.hasOwnProperty.call(KEY_SHAPE_INDEX, cleaned) ? KEY_SHAPE_INDEX[cleaned] : null;
}

// Monta o link do Cifra Club ja no tom certo, a partir do link base
// cadastrado (sem keyShape ou com qualquer keyShape) e do campo "Tom" da
// musica. Só mexe em links do proprio cifraclub.com.br -- outros sites de
// cifra ficam como estao, sem alteracao.
export function cifraUrlComTom(lyricsUrl, tom) {
  if (!lyricsUrl) return lyricsUrl;
  const shape = keyShapeFor(tom);
  if (shape === null) return lyricsUrl;
  try {
    const url = new URL(lyricsUrl);
    if (!url.hostname.endsWith("cifraclub.com.br")) return lyricsUrl;
    url.searchParams.set("keyShape", String(shape));
    return url.toString();
  } catch {
    return lyricsUrl;
  }
}
